import PropTypes from 'prop-types';
import * as index from './icons/index.js';

var propTypes = {
    name: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    size: PropTypes.number,
    color: PropTypes.string,
    className: PropTypes.string,
    iconSet: PropTypes.object,
    relativeSize: PropTypes.string,
    noMargin: PropTypes.bool,
};
var defaultProps = {
    size: 44,
    color: '',
    iconSet: index,
};

export { defaultProps, propTypes };
